import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Landing from "@/pages/Landing";
import { CustomCursor } from "@/components/site/CustomCursor";
import { Toaster } from "@/components/ui/sonner";

const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminLeads = lazy(() => import("@/pages/AdminLeads"));
const AdminOrders = lazy(() => import("@/pages/AdminOrders"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("@/pages/PaymentCancel"));

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <div className="App grain">
        <BrowserRouter>
          <CustomCursor />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="light" />
      </div>
    </MotionConfig>
  );
}

export default App;
